import { Alert } from "@blueprintjs/core";
import { useCallback, useEffect, useState } from "react";

const AUTO_UPDATE_COUNTDOWN_SECONDS = 60;

type UpdateAvailableDialogProps = {
  automatic?: boolean;
  onClose: () => void;
};

export const UpdateAvailableDialog = ({
  automatic = false,
  onClose,
}: UpdateAvailableDialogProps) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(
    AUTO_UPDATE_COUNTDOWN_SECONDS,
  );
  const relaunch = useCallback(() => {
    setIsConfirmed(true);
    window.location.reload();
  }, []);

  useEffect(() => {
    if (!automatic) return;

    const countdown = window.setInterval(() => {
      setSecondsRemaining((current) => Math.max(0, current - 1));
    }, 1000);
    const restart = window.setTimeout(
      relaunch,
      AUTO_UPDATE_COUNTDOWN_SECONDS * 1000,
    );

    return () => {
      window.clearInterval(countdown);
      window.clearTimeout(restart);
    };
  }, [automatic, relaunch]);

  return (
    <Alert
      isOpen={true}
      icon="info-sign"
      onConfirm={relaunch}
      loading={isConfirmed}
      confirmButtonText={automatic ? "Restart Now" : "Relaunch"}
      intent="success"
      cancelButtonText={automatic ? "Delay for 5 minutes" : "Cancel"}
      onCancel={onClose}
    >
      <b>A new version of Job Manager is available</b>
      <p>
        Relaunching will refresh your browser. Any unsaved work will be lost.
      </p>
      {automatic && (
        <p>
          Job Manager will restart in <b>{secondsRemaining}</b> seconds.
        </p>
      )}
    </Alert>
  );
};
